
import { supabase } from '@/lib/supabase'

/**
 * Récupère l'ID du plan d'abonnement dans la base de données
 */
export async function getPlanSubscriptionId(planName: string): Promise<string | undefined> {
  console.log('Récupération de l\'ID du plan:', planName);
  try {
    const { data: planData, error: planError } = await supabase
      .from('subscription_plans')
      .select('id')
      .eq('name', planName)
      .single();
      
    if (planError) {
      console.error('Erreur lors de la récupération du plan:', planError);
      return undefined;
    }
    
    const subscription_plan_id = planData?.id;
    console.log('ID du plan récupéré:', subscription_plan_id);
    return subscription_plan_id;
  } catch (error) {
    console.error('Erreur lors de la récupération du plan:', error);
    return undefined;
  }
}
